import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiEndPoints } from './api.endPoints';
import { Metadata } from './dataTypes';
import { HttpService } from './http.service';

export const fetchDeclineConditions = createAsyncThunk(
  'metadata/fetchDeclineConditions',
  async () => {
    const response = await HttpService.getInstance().get(
      apiEndPoints.declineConditions,
    );
    if (response && !response.error) {
      return { items: response.parsedBody };
    }
    return { items: [] };
  },
);

export const fetchPostponeConditions = createAsyncThunk(
  'metadata/fetchPostponeConditions',
  async () => {
    const response = await HttpService.getInstance().get(
      apiEndPoints.postponeConditions,
    );
    if (response && !response.error) {
      return { items: response.parsedBody };
    }
    return { items: [] };
  },
);

export const metadataSlice = createSlice({
  name: 'metadata',

  initialState: {
    declineConditions: {
      loading: false,
      items: [] as Metadata[],
    },
    postponeConditions: {
      loading: false,
      items: [] as Metadata[],
    },
  },

  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchDeclineConditions.pending, state => {
      state.declineConditions.loading = true;
    });
    builder.addCase(fetchDeclineConditions.fulfilled, (state, action) => {
      state.declineConditions.items = action.payload.items;
      state.declineConditions.loading = false;
    });
    builder.addCase(fetchDeclineConditions.rejected, state => {
      state.declineConditions.loading = false;
    });

    builder.addCase(fetchPostponeConditions.pending, state => {
      state.postponeConditions.loading = true;
    });
    builder.addCase(fetchPostponeConditions.fulfilled, (state, action) => {
      state.postponeConditions.items = action.payload.items;
      state.postponeConditions.loading = false;
    });
    builder.addCase(fetchPostponeConditions.rejected, state => {
      state.postponeConditions.loading = false;
    });
  },
});

export const metadataReducer = metadataSlice.reducer;
export const metadataActions = metadataSlice.actions;
